import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import MainPage from "./pages/MainPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import CookiesPage from "./pages/CookiesPage";
import BlogList from "./pages/BlogList";
import PostDigitalizarRestaurante from "./pages/posts/PostDigitalizarRestaurante";
import PostBeneficios from "./pages/posts/PostBeneficios";
import PostErrores from "./pages/posts/PostErrores";
import PostReservas from "./pages/posts/PostReservas";
import PostChecklist from "./pages/posts/PostChecklist";
import Restaurant from "./pages/Restaurant";
import Demo from "./pages/Demo";
import RestaurantCarta from "./pages/RestaurantCarta";
import Barber2 from "./pages/Barber2";
import Salon2 from "./pages/Salon2";
import SalonesDemos from "./pages/SalonesDemo";
import Trainers from "./pages/Trainers";
import TrainersDemo from "./pages/TrainersDemo";
import Shop from "./pages/Shop";
import ShopDemo from "./pages/ShopDemo";
import Referrals from "./pages/Referrals";
import ReferralRedirect from "./pages/ReferralRedirect";
import Portfolio from "./pages/Portfolio";
import ScrollToTop from "./components/ScrollToTop";
// import AIPreSalesChat from "./components/AIPreSalesChat";

function App() {
	return (
		<HelmetProvider>
			<Router>
				<ScrollToTop />
				<Routes>
					<Route path="*" element={<MainPage />} />
					<Route path="/es" element={<MainPage />} />
					<Route path="/" element={<MainPage />} />
					<Route path="/restaurantes" element={<Restaurant />} />
					<Route path="/barberias" element={<Barber2 />} />
					<Route path="/barberias2" element={<Barber2 />} />
					<Route path="/salones" element={<Salon2 />} />
					<Route path="/salones2" element={<Navigate to="/salones" replace />} />
					<Route path="/tiendas" element={<Shop />} />
					<Route path="/tiendas/demo" element={<ShopDemo />} />
					<Route path="/salones/demo" element={<SalonesDemos />} />
					<Route path="/entrenadores" element={<Trainers />} />
					<Route path="/entrenadores/demo" element={<TrainersDemo />} />
				<Route path="/restaurantes/carta" element={<RestaurantCarta />} />
				<Route path="/restaurantes/demo" element={<Demo />} />
					<Route path="/blog" element={<BlogList />} />
					<Route
						path="/blog/digitalizar-restaurante"
						element={<PostDigitalizarRestaurante />}
					/>
					<Route
						path="/blog/errores-digitalizacion"
						element={<PostErrores />}
					/>
					<Route path="/blog/reservas-online" element={<PostReservas />} />
					<Route
						path="/blog/checklist-digitalizacion"
						element={<PostChecklist />}
					/>
					<Route path="/blog/beneficios-app" element={<PostBeneficios />} />
					<Route path="/terminos" element={<TermsPage />} />
					<Route path="/politica-privacidad" element={<PrivacyPage />} />
					<Route path="/cookies" element={<CookiesPage />} />
					<Route path="/referidos" element={<Referrals />} />
					<Route path="/r/:code" element={<ReferralRedirect />} />
					<Route path="/ejemplos" element={<Portfolio />} />
				</Routes>
				{/* <AIPreSalesChat /> */}
			</Router>
		</HelmetProvider>
	);
}

export default App;
